import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "checkbox-input" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Name", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.Name) = $event)),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSlug()))
      }, null, 544), [
        [_vModelText, _ctx.formData.Name]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.Template) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.formData.Template]
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Is Template", -1))
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("h3", null, "Start From Template", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.SheetJSON) = $event)),
        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.checkTemplate()))
      }, [
        _cache[9] || (_cache[9] = _createElementVNode("option", { value: null }, "No Template", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (template, i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: i,
            value: template.SheetJSON
          }, _toDisplayString(template.Name), 9, _hoisted_5))
        }), 128))
      ], 544), [
        [_vModelSelect, _ctx.formData.SheetJSON]
      ]),
      (_ctx.formData.CompanyScorecard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Year", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.Year) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: year
                }, _toDisplayString(year), 9, _hoisted_7))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.formData.Year]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
        type: "submit",
        value: "Submit",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submit()))
      }, null, 2)
    ])
  ]))
}